import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=4d0a7ace&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=4d0a7ace&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0a7ace",
  null
  
)

export default component.exports